import React from 'react';
import { X } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import GMap from '../maps/GMap';

const OfferLocationsModal = ({ open, onOpenChange, locations }) => {
  const { t } = useLanguage();

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/50"
        onClick={() => onOpenChange(false)}
      />

      {/* Modal Content */}
      <div className="relative w-full h-full bg-white flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between px-4 py-4 border-b border-theme-border">
          <h2 className="text-lg font-bold text-theme-secondary">
            {t('offerLocations.modalTitle') || 'Store Locations'}
          </h2>
          <button
            onClick={() => onOpenChange(false)}
            className="p-2 hover:bg-theme-secondary-foreground rounded-full transition-colors"
            aria-label="Close"
          >
            <X className="w-5 h-5 text-theme-secondary" />
          </button>
        </div>

        {/* Map Container */}
        <div className="flex-1 overflow-hidden">
          {locations && locations.length > 0 ? (
            <GMap locations={locations} />
          ) : (
            <div className="flex items-center justify-center h-full">
              <div className="text-center">
                <p className="text-theme-secondary font-semibold">
                  {t('offerLocations.noLocationsFound') || 'No locations found'}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default OfferLocationsModal;
